/* Product card actions — mockup script.js:234-239. One delegated listener for every .cr-card on the page.
   Quick view: Phase 1 quick view (CR.quickView, assets/cr-cart.js). Add: CR.cart.add → cart drawer opens. */
(function () {
  if (window.CR && window.CR._cardsBound) return;
  document.addEventListener('click', function (e) {
    var card = e.target.closest('[data-cr-card]');
    if (!card || !window.CR) return;

    var qv = e.target.closest('[data-cr-qv]');
    if (qv) {
      e.preventDefault();
      if (window.CR.quickView) window.CR.quickView.open(card.dataset.handle, { trigger: qv });
      return;
    }

    var add = e.target.closest('[data-cr-add]');
    if (!add || add.disabled) return;
    e.preventDefault();
    var id = add.dataset.variantId;
    if (!id) {
      // More than one size: open quick view with the "select a size" reminder (mockup: openQuickView(i, true)).
      if (window.CR.quickView) window.CR.quickView.open(card.dataset.handle, { needSize: true, trigger: add });
      return;
    }
    add.disabled = true;
    add.setAttribute('aria-busy', 'true');
    window.CR.cart.add([{ id: parseInt(id, 10), quantity: 1 }])
      .catch(function () { if (window.CR.quickView) window.CR.quickView.open(card.dataset.handle, { trigger: add }); })
      .then(function () { add.disabled = false; add.removeAttribute('aria-busy'); });
  });
  if (window.CR) window.CR._cardsBound = true;
})();
